import { render, staticRenderFns } from "./ArrivedCheckouts.vue?vue&type=template&id=18ce933a"
import script from "./ArrivedCheckouts.vue?vue&type=script&lang=js"
export * from "./ArrivedCheckouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports